import {
  REQUEST_ERROR,
  REQUEST_START,
  REQUEST_SUCCESS
} from '../../../../../middlewares/api/actions';
import {
  LOADER_CSV_FORM_MAPPING_CONTROL_DETAIL_MAPPING_CUBE_READ,
  LOADER_CSV_FORM_MAPPING_CONTROL_DETAIL_MAPPING_HIDE,
  LOADER_CSV_FORM_MAPPING_CONTROL_DETAIL_MAPPING_READ,
  LOADER_CSV_FORM_MAPPING_CONTROL_DETAIL_MAPPING_SHOW,
  LOADER_CSV_FORM_MAPPING_CONTROL_MAPPING_SET,
  LOADER_CSV_FORM_MAPPING_CONTROL_MAPPINGS_HIDE,
  LOADER_CSV_FORM_MAPPING_CONTROL_MAPPINGS_READ,
  LOADER_CSV_FORM_MAPPING_CONTROL_MAPPINGS_SHOW,
  LOADER_CSV_FORM_MAPPING_CONTROL_SELECTED_MAPPING_CUBE_READ,
  LOADER_CSV_FORM_MAPPING_CONTROL_SELECTED_MAPPING_HIDE,
  LOADER_CSV_FORM_MAPPING_CONTROL_SELECTED_MAPPING_SHOW,
  LOADER_CSV_FORM_MAPPING_CONTROL_DETAIL_SEQUENCE_MAPPING_SHOW,
  LOADER_CSV_FORM_MAPPING_CONTROL_DETAIL_SEQUENCE_MAPPING_HIDE,
  LOADER_CSV_FORM_MAPPING_CONTROL_DETAIL_SEQUENCE_MAPPING_READ,
  LOADER_CSV_FORM_MAPPING_CONTROL_SEQUENCE_MAPPING_SET,
} from './actions';
import {getCubesTree} from "../../../../../utils/treeBuilders";
import {
  getCategorisedObjectsTree,
  getFilteredTreeWithPaths,
  getMappedTree
} from "../../../../../utils/tree";

const loaderCsvFormMappingControlReducer = (
  state = {
    isSelectedMappingVisible: false,
    isMappingsVisible: false,
    mappingsTree: null,
    detailMappingId: null,
    detailMapping: null,
    detailMappingCube: null,
    detailSequenceMappingId: null,
    detailSequenceMapping: null,
  },
  action
) => {
  switch (action.type) {
    case LOADER_CSV_FORM_MAPPING_CONTROL_MAPPING_SET:
    case LOADER_CSV_FORM_MAPPING_CONTROL_SEQUENCE_MAPPING_SET:
      return {
        ...state,
        isMappingsVisible: false
      };
    case LOADER_CSV_FORM_MAPPING_CONTROL_MAPPINGS_SHOW:
      return {
        ...state,
        isMappingsVisible: true
      };
    case LOADER_CSV_FORM_MAPPING_CONTROL_DETAIL_MAPPING_SHOW:
      return {
        ...state,
        detailMappingId: action.mappingId
      };
    case LOADER_CSV_FORM_MAPPING_CONTROL_SELECTED_MAPPING_SHOW:
      return {
        ...state,
        isSelectedMappingVisible: true
      };
    case LOADER_CSV_FORM_MAPPING_CONTROL_MAPPINGS_HIDE:
      return {
        ...state,
        isMappingsVisible: false,
        mappingsTree: null,
      };
    case LOADER_CSV_FORM_MAPPING_CONTROL_DETAIL_MAPPING_HIDE:
      return {
        ...state,
        detailMappingId: null,
        detailMapping: null,
        detailMappingCube: null
      };
    case LOADER_CSV_FORM_MAPPING_CONTROL_SELECTED_MAPPING_HIDE:
      return {
        ...state,
        isSelectedMappingVisible: false
      };
    case LOADER_CSV_FORM_MAPPING_CONTROL_DETAIL_SEQUENCE_MAPPING_SHOW:
      return {
        ...state,
        detailSequenceMappingId: action.sequenceMappingId
      };
    case LOADER_CSV_FORM_MAPPING_CONTROL_DETAIL_SEQUENCE_MAPPING_HIDE:
      return {
        ...state,
        detailSequenceMappingId: null,
        detailSequenceMapping: null,
        detailMappingCube: null
      };
    case REQUEST_START: {
      switch (action.label) {
        case LOADER_CSV_FORM_MAPPING_CONTROL_MAPPINGS_READ:
          return {
            ...state,
            mappingsTree: null
          };
        case LOADER_CSV_FORM_MAPPING_CONTROL_DETAIL_MAPPING_READ:
          return {
            ...state,
            detailMapping: null
          };
        case LOADER_CSV_FORM_MAPPING_CONTROL_DETAIL_MAPPING_CUBE_READ:
          return {
            ...state,
            detailMappingCube: null
          };
        case LOADER_CSV_FORM_MAPPING_CONTROL_DETAIL_SEQUENCE_MAPPING_READ:
          return {
            ...state,
            detailSequenceMapping: null
          }
        default:
          return state;
      }
    }
    case REQUEST_ERROR: {
      switch (action.label) {
        case LOADER_CSV_FORM_MAPPING_CONTROL_MAPPINGS_READ:
          return {
            ...state,
            isMappingsVisible: false
          };
        case LOADER_CSV_FORM_MAPPING_CONTROL_DETAIL_MAPPING_READ:
          return {
            ...state,
            detailMappingId: null
          };
        case LOADER_CSV_FORM_MAPPING_CONTROL_SELECTED_MAPPING_CUBE_READ:
          return {
            ...state,
            isSelectedMappingVisible: false,
          };
        case LOADER_CSV_FORM_MAPPING_CONTROL_DETAIL_SEQUENCE_MAPPING_READ:
          return {
            ...state,
            detailSequenceMappingId: null,
            detailSequenceMapping: null
          }
        default:
          return state;
      }
    }
    case REQUEST_SUCCESS: {
      switch (action.label) {
        case LOADER_CSV_FORM_MAPPING_CONTROL_MAPPINGS_READ:
          let [allCubes, dcs, mappings, sequenceMappings] = action.response;
          if (action.format === 'xls') {
            mappings = mappings.filter(mapping => mapping.XMLFilePath !== null && !mapping.PluginId) || [];
          }
          if (action.format === 'plugin' && !action.sequenceMappingEnabled) {
              sequenceMappings = [];
          }
          if (action.format === 'plugin' && !!action.pluginId) {
            mappings = mappings.filter(mapping => mapping.PluginId === action.pluginId) || [];
          }
          if (action.format !== 'plugin' && action.format !== 'xls') {
            sequenceMappings = [];
            mappings = mappings.filter(mapping => mapping.XMLFilePath === null && !mapping.PluginId) || [];
          }
          const treeWithCategories = getCubesTree(allCubes, dcs);

          const treeWithCategoriesOrd = getMappedTree(treeWithCategories, "children", node => {
            let ordCount = 1;
            return {
              ...node,
              TreeID: node.CatCode ? `Cat_${node.CatCode}` : `${node.Code}`,
              children:
                node.children
                  ? node.children
                    .sort((a, b) => {
                      if (a.Ord !== undefined && b.Ord !== undefined) {
                        return a.Ord - b.Ord;
                      } else if (a.Ord !== undefined) {
                        return a;
                      } else if (b.Ord !== undefined) {
                        return b;
                      } else {
                        return (a.CatCode || -1) - (b.CatCode || -1);
                      }
                    })
                    .map(c => ({
                      ...c,
                      Ord: c.Ord !== undefined ? String(ordCount++) : undefined
                    }))
                  : node.children
            };
          });

          const mappingsMap = mappings.map(mapping => ({
            ...mapping,
            TreeID: `Mapp_${mapping.IDMapping}`
          })) || [];

          const sequenceMappingsMap = sequenceMappings.map(seqMapping => ({
            ...seqMapping,
            TreeID: `SeqMapp_${seqMapping.IDSeqMapping}`
          })) || [];

          const treeWithMappings = getCategorisedObjectsTree(
            [...sequenceMappingsMap, ...mappingsMap],
            treeWithCategoriesOrd,
            "children",
            (a, b) => {
              if (a.IDMapping && b.IDMapping) {
                return a.IDMapping - b.IDMapping
              } else {
                return a.IDSeqMapping - b.IDSeqMapping
              }
            },
            (mapping, cube) => {
              if (cube) {
                return cube.IDCube === mapping.IDCube;
              } else {
                return true;
              }
            },
            null,
            null,
            true
          );

          const cleanedTreeWithMappings = getFilteredTreeWithPaths(
            treeWithMappings,
            "children",
            node =>
              node.IDMapping ||
              (node.children && node.children.filter(({IDMapping}) => IDMapping).length > 0) ||
              node.IDSeqMapping ||
              (node.children && node.children.filter(({IDSeqMapping}) => IDSeqMapping).length > 0)
          );

          return {
            ...state,
            mappingsTree: cleanedTreeWithMappings
          };
        case LOADER_CSV_FORM_MAPPING_CONTROL_DETAIL_MAPPING_READ:
          return {
            ...state,
            detailMapping: action.response
          };
        case LOADER_CSV_FORM_MAPPING_CONTROL_DETAIL_MAPPING_CUBE_READ:
          return {
            ...state,
            detailMappingCube: action.response
          };
        case LOADER_CSV_FORM_MAPPING_CONTROL_DETAIL_SEQUENCE_MAPPING_READ:
          return {
            ...state,
            detailSequenceMapping: action.response
          }
        default:
          return state;
      }
    }
    default:
      return state;
  }
};

export default loaderCsvFormMappingControlReducer;
